import { css } from 'styled-components';
import { websiteTheme } from './websiteTheme';
import { WebsiteKind, WebsiteSize, WebsiteType } from './websiteTypes';

export const websiteTypographyMixin = (kind: WebsiteKind, size: WebsiteSize, type: WebsiteType) => {
  const kindBranch = websiteTheme[kind];

  if (!(size in kindBranch)) {
    throw new Error(`Website typography: ${size} size is not supported for website/${kind} typography`);
  }
  const sizeBranch = kindBranch[size as Extract<keyof typeof kindBranch, WebsiteSize>];

  if (!(type in sizeBranch)) {
    throw new Error(`Website typography: ${type} type is not supported for website/${kind}/${size} typography`);
  }
  const typeBranch = sizeBranch[type as Extract<keyof typeof sizeBranch, WebsiteType>];

  return css`
    font-family: ${kindBranch.fontFamily};
    font-size: ${sizeBranch.fontSize};
    line-height: ${sizeBranch.lineHeight};
    color: ${typeBranch.color};
    font-weight: ${typeBranch.fontWeight};
  `;
};
